var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "locations_tab" } },
    [
      !_vm.selectedPlace
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-baseline heading-container",
              },
              [
                _c("div", { staticClass: "heading" }, [
                  _c("h2", [
                    _vm._v(
                      _vm._s(_vm.$t("locationsTab.allLocationsSection.title"))
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("locationsTab.allLocationsSection.description")
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "bb-btn btn-success add-location-btn",
                    on: {
                      click: function ($event) {
                        return _vm.createPlace()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "locationsTab.allLocationsSection.createPlaceBtn"
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "locations-list mt-3" },
              _vm._l(_vm.allPlaces, function (place) {
                return _c(
                  "div",
                  {
                    key: place.id,
                    staticClass: "bb-card location-list-item",
                    on: {
                      click: function ($event) {
                        return _vm.selectPlace(place)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "location-item-details" }, [
                      _c("div", { staticClass: "location-logo-holder" }, [
                        !place.logo
                          ? _c(
                              "div",
                              { staticClass: "location-logo-placeholder" },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "feather feather-image",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "39",
                                      height: "39",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "1.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "3",
                                        y: "3",
                                        width: "18",
                                        height: "18",
                                        rx: "2",
                                        ry: "2",
                                      },
                                    }),
                                    _c("circle", {
                                      attrs: { cx: "8.5", cy: "8.5", r: "1.5" },
                                    }),
                                    _c("polyline", {
                                      attrs: { points: "21 15 16 10 5 21" },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("img", {
                          staticClass: "location-logo",
                          attrs: { src: place.logo },
                        }),
                      ]),
                      _c("div", { staticClass: "location-info" }, [
                        _c("p", { staticClass: "location-name" }, [
                          _vm._v(_vm._s(place.name)),
                        ]),
                        _c("span", { staticClass: "location-address" }, [
                          _vm._v(_vm._s(place.address)),
                        ]),
                      ]),
                    ]),
                    _vm._m(0, true),
                  ]
                )
              }),
              0
            ),
            _c(
              "button",
              {
                staticClass: "mobile-new-place-btn",
                on: {
                  click: function ($event) {
                    return _vm.createPlace()
                  },
                },
              },
              [_c("i", { staticClass: "la la-plus" })]
            ),
          ])
        : _vm._e(),
      _vm.selectedPlace
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-baseline mb-10 selected-place-heading-section",
                },
                [
                  _c("div", { staticClass: "heading" }, [
                    _c("h2", [
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.unsetSelectedPlace()
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "feather feather-arrow-left",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("line", {
                                attrs: {
                                  x1: "19",
                                  y1: "12",
                                  x2: "5",
                                  y2: "12",
                                },
                              }),
                              _c("polyline", {
                                attrs: { points: "12 19 5 12 12 5" },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" " + _vm._s(_vm.selectedPlace.name) + " "),
                    ]),
                  ]),
                  _c("BBDropdown", {
                    staticClass: "selected-location-options-dropdown",
                    attrs: { positionClass: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "toggle",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "selected-location-options-toggle",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "locationsTab.selectedPlaceSection.dropdown.toggleBtn"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("i", { staticClass: "la la-angle-down" }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "items",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "action-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.editBasicInfo(
                                        _vm.selectedPlace
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "locationsTab.selectedPlaceSection.dropdown.editBtn"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "action-item danger",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deletePlace()
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "locationsTab.selectedPlaceSection.dropdown.deleteBtn"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      485398105
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between alig-items-center mb-4 selected-place-cards-holder",
                },
                [
                  _c(
                    "div",
                    { staticClass: "bb-card mr-2 location-details-card" },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _c("span", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "locationsTab.selectedPlaceSection.detailsCard.title"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "card-header-action-btn",
                            on: {
                              click: function ($event) {
                                return _vm.editBasicInfo(_vm.selectedPlace)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "locationsTab.selectedPlaceSection.detailsCard.editBtn"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "location-details-item" }, [
                          _c("p", { staticClass: "location-details-label" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "locationsTab.selectedPlaceSection.detailsCard.emailLabel"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "button",
                            { staticClass: "location-details-action-btn" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.selectedPlace.email) + " "
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "location-details-item" }, [
                          _c("p", { staticClass: "location-details-label" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "locationsTab.selectedPlaceSection.detailsCard.phoneLabel"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "button",
                            { staticClass: "location-details-action-btn" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.selectedPlace.phone) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  !_vm.currentUser.isInLawIndustry
                    ? _c("div", { staticClass: "bb-card ml-2" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _c("span", { staticClass: "card-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "locationsTab.selectedPlaceSection.categoryCard.title"
                                )
                              )
                            ),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "card-header-action-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.editCategories(_vm.selectedPlace)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "locationsTab.selectedPlaceSection.categoryCard.editBtn"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "location-details-item" }, [
                            _c("p", { staticClass: "location-details-label" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "locationsTab.selectedPlaceSection.categoryCard.mainCategoryLabel"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _vm.selectedPlace.mainCategory
                              ? _c(
                                  "span",
                                  { staticClass: "location-details-text" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedPlace.mainCategory.name
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            !_vm.selectedPlace.mainCategory
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "location-details-action-btn",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "locationsTab.selectedPlaceSection.categoryCard.addBtn"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "location-details-item" }, [
                            _c("p", { staticClass: "location-details-label" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "locationsTab.selectedPlaceSection.categoryCard.additionalCategoryLabel"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _vm.selectedPlace.additionalCategories.length > 0
                              ? _c(
                                  "span",
                                  { staticClass: "location-details-text" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.additionalCategoriesString) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.selectedPlace.additionalCategories.length < 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "location-details-action-btn",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "locationsTab.selectedPlaceSection.categoryCard.addBtn"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between alig-items-center mb-4 selected-place-cards-holder",
                },
                [
                  _c("div", { staticClass: "bb-card mr-2" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("span", { staticClass: "card-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "locationsTab.selectedPlaceSection.openingHoursCard.title"
                            )
                          )
                        ),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "card-header-action-btn",
                          on: {
                            click: function ($event) {
                              return _vm.editOpeningHours(_vm.selectedPlace)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "locationsTab.selectedPlaceSection.openingHoursCard.editBtn"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      _vm._l(
                        _vm.openingHours,
                        function (openingHoursItem, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "opening-hours-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "opening-hours-item-badge",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M8.74998 0C3.9175 0 0 3.9175 0 8.74998C0 13.5825 3.9175 17.5 8.74998 17.5C13.5825 17.5 17.5 13.5825 17.5 8.74998C17.4948 3.91966 13.5803 0.00516357 8.74998 0ZM9.37499 8.74998C9.37499 9.09517 9.09517 9.37499 8.74998 9.37499H3.75C3.40481 9.37499 3.12499 9.09517 3.12499 8.74998C3.12499 8.40479 3.40481 8.12497 3.75 8.12497H8.12501V3.75C8.12501 3.40481 8.40483 3.12499 8.75002 3.12499C9.09521 3.12499 9.37499 3.40481 9.37499 3.75V8.74998Z",
                                                  fill: "#CBD6E2",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "opening-hours-item-text",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "opening-hours-item-days",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(openingHoursItem.day)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "opening-hours-item-time",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(openingHoursItem.time)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bb-card ml-2 location-photos-card" },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _c("span", { staticClass: "card-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "locationsTab.selectedPlaceSection.photosCard.title"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "card-header-action-btn",
                            on: {
                              click: function ($event) {
                                return _vm.openImagesModal()
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "locationsTab.selectedPlaceSection.photosCard.editBtn"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "div",
                          { staticClass: "location-images-container" },
                          [
                            _vm._l(_vm.selectedPlace.images, function (image) {
                              return _c(
                                "div",
                                {
                                  key: image.id,
                                  staticClass: "location-image",
                                },
                                [_c("img", { attrs: { src: image.url } })]
                              )
                            }),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.selectedPlace.images.length === 0,
                                    expression:
                                      "selectedPlace.images.length === 0",
                                  },
                                ],
                                staticClass: "location-image",
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "feather feather-image",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "40",
                                      height: "40",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "1.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "3",
                                        y: "3",
                                        width: "18",
                                        height: "18",
                                        rx: "2",
                                        ry: "2",
                                      },
                                    }),
                                    _c("circle", {
                                      attrs: { cx: "8.5", cy: "8.5", r: "1.5" },
                                    }),
                                    _c("polyline", {
                                      attrs: { points: "21 15 16 10 5 21" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "location-images-description" },
                          [
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "locationsTab.selectedPlaceSection.photosCard.label"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "locationsTab.selectedPlaceSection.photosCard.description"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _c("LocationInput", {
                attrs: {
                  latitude: _vm.selectedPlace.latitude,
                  longitude: _vm.selectedPlace.longitude,
                  locationName: _vm.selectedPlace.name,
                  address: _vm.selectedPlace.address,
                },
                on: {
                  updateLocation: function ($event) {
                    return _vm.updatePlaceLocation($event)
                  },
                },
              }),
              _c("PlaceImagesModal", {
                ref: "placeImagesModal",
                attrs: { place: _vm.selectedPlace },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mobileActionsVisible,
                      expression: "mobileActionsVisible",
                    },
                  ],
                  attrs: { id: "mobile_selected_place_actions_overlay" },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.handleMobileActionsOutsideClick,
                          expression: "handleMobileActionsOutsideClick",
                        },
                      ],
                      staticClass: "mobile-selected-place-actions-container",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mobile-selected-place-actions" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "mobile-selected-place-action-btn",
                              on: {
                                click: function ($event) {
                                  _vm.editBasicInfo(_vm.selectedPlace)
                                  _vm.hideMobileActions()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "locationsTab.selectedPlaceSection.mobileButtons.editBtn"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "mobile-selected-place-action-btn danger",
                              on: {
                                click: function ($event) {
                                  _vm.hideMobileActions()
                                  _vm.deletePlace()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "locationsTab.selectedPlaceSection.mobileButtons.deleteBtn"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "mobile-selected-place-action-btn",
                          on: {
                            click: function ($event) {
                              return _vm.hideMobileActions()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "locationsTab.selectedPlaceSection.mobileButtons.closeBtn"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("PlaceFormModal", { ref: "placeFormModal" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "location-actions" }, [
      _c("button", { staticClass: "see-location-btn" }, [
        _c("i", { staticClass: "la la-angle-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }